export class LocalStorageConstants {
  static API_TOKEN_KEY = 'oss-api-token';
  static SERVICE_LOCATION_KEY = 'serviceLocation';
  static USER_KEY = 'oss_user';
  static UNIT_KEY = 'unit';
  static ASSIGNMENT_ID_KEY = 'assignmentId';
}
